import React, { useState } from 'react';


export const Search = ({ setQuestion, type }) => {

    const [inputValue, setInputValue] = useState('');


    const handleChange = (e) => {
        setInputValue(e.target.value);
        let value = e.target.value;

        setTimeout(() => {
            setQuestion(value);
        }, 200);

    };

    const handleSubmit = (e) => {
        e.preventDefault();

    };

    const handleClick = () => {
        setQuestion(inputValue);
    };

    return (
        <div className='searchComponent'>
            <form className='searchForm' onSubmit={handleSubmit}>
                <input
                    className='input form-control'
                    type={type == 'info' ? 'number' : 'text'}
                    placeholder={type == 'info' ? 'Buscá tu grupo' : 'Buscá por palabras clave'}
                    name='search'
                    onChange={handleChange}
                    autoComplete='off'
                />
                <button className='button' onClick={handleClick} type='submit'>
                    Buscar
                </button>
            </form>
        </div>
    )
}
